export enum Error {
  NOT_FOUND = 'not found',
  INVALID_INPUT = 'invalid input',
  INVALID_BUFFER_LENGTH = 'invalid byteArray length',
  UNKNOWN_VALUETYPE = 'unknown valueType',
  NOT_IMPLEMENTED = 'not yet implemented',
  NO_VALUETYPE = 'no valueType',
  NOT_WRITEABLE = 'not writeable',
  VALUE_OUT_OF_RANGE = 'value out of range',
  INVALID_PHONENUMBER = 'invalid phone number',
  NAN = 'not a number',
  NOT_A_INT = 'not a integer',
  DEVICE_HAS_NO_FIRMWARE_VERSION = 'device has no firmware version',
  FIRMWARE_VERSION_TOO_SMALL = 'firmware version on device is too small',
  PCBTYPE_VERSION_TOO_SMALL = 'pcb type version on device is too small',
  INVALID_RANGE = 'valid value range needs to be undefined or have a min and a max value or a list',
  INVALID_LIST = 'list valid value range not allowed for valueType string or phone number',
  RANGE_VALUETYPE_EXCEPTION = 'parsing range for this value type is not implemented',
  PARAMETER_MISSMATCH = 'parameter id does not match parameter config',

  PARAMETER_REQUIRES_FIRMWARE = 'parameter requires a min firmware. Please provide the firmware of the device to validate',
  PARAMETER_REQUIRES_PCBTYPE = 'parameter requires a min pcbType. Please provide the pcbType of the device to validate',
  PCBTYPE_MISSMACTCH = 'id of pcbType in config and minPcbType are not matching',

  PARAMETER_NOT_SET = 'parameter was not provided',
  MIN_BEACON_FREQUENCY_PARAMETER_NOT_SET = 'min beacon frequency parameter was not provided',
  MAX_BEACON_FREQUENCY_PARAMETER_NOT_SET = 'max beacon frequency parameter was not provided',
  PARAMETER_CONFIG_NOT_SET = 'parameterConfig was not provided',
  PCB_TYPE_NOT_SET = 'pcb type not provided',
  SUBSYSTEM_NOT_SET = 'subsystem not provided',
}
